import type { EntityChangeEventFrame } from './serverMessage';

type Listener = (frame: EntityChangeEventFrame) => void;

/**
 * Process-wide bus for field-level change events. Exposed for future consumers (none yet);
 * a throwing listener is isolated so one bad consumer cannot starve the others.
 */
class EntityChangeEventBus {
  private readonly listeners = new Set<Listener>();

  emit(frame: EntityChangeEventFrame): void {
    for (const listener of this.listeners) {
      try {
        listener(frame);
      } catch {
        // isolate a throwing subscriber
      }
    }
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }
}

export const entityChangeEventBus = new EntityChangeEventBus();
